import { alpha } from '@material-ui/core/styles'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { HarmonyTheme } from 'declarations/mui-theme-harmony-augment'

const px = (n: number) => pxToRem(n) as string

const textHeader = '#373F4E'
const brandMain = '#30659F'
const shadow = alpha(textHeader, 0.06)
// Header accent-strip color — its own Figma gradient spec, not one of the 7 core palette swatches.
const headerAccentColor = '#5077FF'

export const harmonyTheme: HarmonyTheme = {
    colors: {
        headerBackground: '#FFFFFF',
        strokeWeak: '#E0E4EB',
        textHeader,
        textParagraph: '#646D82',
        brandMain,
        focusRing: '#254E7A',
        logoAccent: '#2A78C6',
        hoverBg: alpha(brandMain, 0.08),
        activeBg: alpha(brandMain, 0.16),
        shadow,
        panelShadow: `0px 1px 3px ${shadow}`,
        // Wide 0-25%/75-100% fade ramps so it reads as a true gradient, not a solid bar with soft corners.
        headerAccentGradient: `linear-gradient(90deg, ${alpha(
            headerAccentColor,
            0.15
        )} 0%, ${alpha(headerAccentColor, 0.55)} 25%, ${alpha(
            headerAccentColor,
            0.55
        )} 75%, ${alpha(headerAccentColor, 0.15)} 100%)`,
    },
    typography: {
        tabLabel: {
            fontFamily: 'Lexend, sans-serif',
            fontSize: px(14),
            fontWeight: 400,
        },
        userName: {
            fontFamily: 'Lexend, sans-serif',
            fontSize: px(13),
            fontWeight: 600,
        },
        avatarInitials: {
            fontFamily: 'Lexend, sans-serif',
            fontSize: px(12),
            fontWeight: 400,
        },
    },
}
